import BaseSportPage from '../components/shared/BaseSportPage';
export default function Tennis() {
  return <BaseSportPage sport="tennis" label="Tennis" />;
}
